import * as React from 'react';

import { BannerContainer } from '../../../serp/containers/Banner';
import { IIntegrateAdOptions } from '../types';

export interface IGetServicesBannerParams {
  offersLength: number;
  positionOffset: number;
  position: number;
  servicesBannerPositions: number[];
  suggestionFragment: IIntegrateAdOptions['suggestionFragment'];
  willCarouselBannerBeShown: boolean | undefined;
  isAgent?: boolean;
  options: IIntegrateAdOptions;
  locationId?: number;
  isCountrysideBuildersBannerAvailable?: boolean;
}

/**
 * Определяет, нужно ли показывать сервисный баннер
 * Не показываем SERVICES BANNER в основной выдаче, если уже показан BannerContainer для карусели
 * В добивках (suggestionFragment.isSimilar) карусель не показывается, поэтому SERVICES BANNER показывается
 * Если isNewbuildingOffersWithBannerCarouselVisible = false, то карусель не показывается, и SERVICES BANNER показывается как обычно
 * @returns React элемент баннера или null
 */
export const getServicesBanner = ({
  offersLength,
  positionOffset,
  position,
  servicesBannerPositions,
  suggestionFragment,
  willCarouselBannerBeShown,
  isAgent,
  options,
  locationId,
  isCountrysideBuildersBannerAvailable,
}: IGetServicesBannerParams): React.ReactNode | null => {
  const shouldShowServicesBanner =
    offersLength !== positionOffset &&
    servicesBannerPositions.includes(position) &&
    (suggestionFragment.isSimilar || willCarouselBannerBeShown === false);

  if (!shouldShowServicesBanner) {
    return null;
  }

  return (
    <BannerContainer
      key={`banner_${position}`}
      isAgent={isAgent}
      options={options}
      position={position}
      locationId={locationId}
      isCountrysideBuildersBannerAvailable={isCountrysideBuildersBannerAvailable}
    />
  );
};
